"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Icon } from "@iconify/react";
import ProductCard from "../ProductCard";
import ProductCarousel from "@/components/common/ProductCarousel";
export default function RelatedProducts(t0) {
  const $ = _c(9);
  const {
    products,
    labelMap
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="text-xl lg:text-2xl text-center lg:text-start">Related Products</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== labelMap) {
    t2 = product => <ProductCard product={product} labelMap={labelMap} />;
    $[1] = labelMap;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== products || $[4] !== t2) {
    t3 = <ProductCarousel items={products} renderItem={t2} />;
    $[3] = products;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="viewall"><Link href="/collections" className="font-heading flex items-center hover:text-primary">View All<Icon icon="mdi:arrow-right" /></Link></div>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <section className="py-4 bg-gray-50"><div className="max-w-7xl mx-auto px-2">{t1}<div>{t3}{t4}</div></div></section>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}